import alertify from 'alertifyjs';

const initFlashMessages = () => {
    alertify.defaults.notifier.position = 'bottom-center';
    const elements = document.querySelectorAll('.flash-message');
    elements.forEach(element =>{
        const type = element.dataset.type;
        const text = element.innerHTML;

        if (type === 'success') {
            alertify.success(text);
        }
        else if(type === 'error' || type === 'warning' || type === 'danger') {
            alertify.error(text);
        }
        else if (type === 'info') {
            alertify.notify(text);
        }
        else {
            alertify.message(text);
        }
    });
}

export default initFlashMessages;